<template lang="pug">
    div
      el-row.labelStyle
        el-col(:span="12")
          app-display(
            label="Cadastro CAR:",
            :content="dadosJson.imovel.numeroReciboCar || '-'"
          )
          app-display(
            label="Denominação:",
            :content="dadosJson.imovel.denominacao || '-'"
          )
          app-display(
            label="Número da Matrícula:",
            :content="dadosJson.imovel.numeroMatricula || '-'"
          )
          app-display(
            label="Averbação de Transferência de Domínio:",
            :content="dadosJson.imovel.averbacaoTransferenciaDominio || '-'"
          )
        el-col(:span="12")
          app-display(
            label="Averbação Georreferenciamento:",
            :content="dadosJson.imovel.averbacaoGeorreferenciamento || '-'"
          )
          app-display(
            label="CNS da Matrícula:",
            :content="dadosJson.imovel.cnsMatricula || '-'"
          )
          app-display(
            label="SNCR:",
            :content="dadosJson.imovel.sncr || '-'"
          )
          app-display(
            label="NIRF:",
            :content="dadosJson.imovel.nirf || '-'"
          )
      el-col(v-if="dadosJson.georreferenciamento.localizacoes && dadosJson.georreferenciamento.localizacoes.length" :span="24")
        div.pad
          app-resumo-mapa(
            :idMapa="'id-mapa-localizacao-rf'"
            :height="30"
            :localizacoes="dadosJson.georreferenciamento.localizacoes.map((l) => l.geometry)",
            :isVisualizarCadastro="true"
          )
      listagem-documentos(
        v-if="dadosJson.imovel.documentos"
        :documentos="dadosJson.imovel.documentos",
        :protocoloCadastroOriginal="dadosJson.protocolo"
        ownerDocumento="IMOVEL"
        :compararDocumentos="null"
        :versaoCadastro = "null"
      )
  </template>
<script>
import AppDivider from '../AppDivider'
import AppDisplay from '../AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import ListagemDocumentos from '../informacoesCadastro/ListagemDocumentos'
import AppResumoMapa from '@/components/resumo/AppResumoMapa'

export default {
  props: {
    dadosJson: {
      type: Object,
      required: false
    }
  },
  components: {
    AppDisplay,
    AppDivider,
    AppDisplayMultiple,
    ListagemDocumentos,
    AppResumoMapa
  },

  methods: {
    formatTelefone (telefones) {
      return telefones.map(telefone => {
        if (telefone?.numero) {
          return telefone.numero + (telefone.identificacao ? ` - ${telefone.identificacao}` : '')
        } else {
          return telefone
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-top {
    margin-top: 10px;
}

>>>.text .text {
    color: #ff0000 !important;
}

@media (max-width: 780px) {
    .labelStyle {
        display: flex;
        flex-direction: column;
        width: 395px;
    }

    .margin-top {
        display: flex;
        flex-direction: column;
        width: 490px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/ImovelRf.vue